"use client";
import { jsx as a, jsxs as _ } from "react/jsx-runtime";
import { Block as u } from "../../primitives/block/block.js";
import { FlexBlock as c } from "../../primitives/flex-block/flex-block.js";
import { Icon as p } from "../icon/icon.js";
import "react";
import { Text as f } from "../text/text.js";
import { Button as b } from "../../primitives/button/button.js";
import l from "clsx";
import g from "react-focus-lock";
import { RemoveScroll as y } from "react-remove-scroll";
import { b as h } from "../../virginmediao2-momentum-icons-icons-far-BQVtGVjv.js";
import { Box as M } from "../box/box.js";
import { useModal as n } from "./modal.context.js";
import '../../assets/modal.css';const B = "_modal_7ym6f_1", F = "_modalFadeIn_7ym6f_1", I = "_modal__header_7ym6f_23", N = "_modal__backdrop_7ym6f_52", m = {
  modal: B,
  modalFadeIn: F,
  modal__header: I,
  "modal__close-button": "_modal__close-button_7ym6f_36",
  modal__backdrop: N
}, q = ({ children: t, ...o }) => /* @__PURE__ */ a(b, { asChild: !0, ...o, children: /* @__PURE__ */ a(k, { children: t }) }), k = ({
  onClick: t,
  ...o
}) => {
  const r = n();
  return /* @__PURE__ */ a(
    "button",
    {
      type: "button",
      onClick: (d) => {
        r == null || r.setIsOpen(!0), t == null || t(d);
      },
      ...o
    }
  );
}, A = ({
  children: t,
  hasBackdrop: o = !0,
  className: r,
  onBackdropClick: d = () => {
  },
  ...s
}) => {
  const e = n();
  return !e || e != null && e.isOpen ? /* @__PURE__ */ a(g, { returnFocus: !0, children: /* @__PURE__ */ _(y, { children: [
    o ? /* @__PURE__ */ a(
      i,
      {
        "data-testid": "modal-backdrop",
        className: m.modal__backdrop,
        onClick: d
      }
    ) : null,
    /* @__PURE__ */ a(
      M,
      {
        role: "dialog",
        "aria-modal": "true",
        direction: "column",
        rounded: "sm",
        border: !0,
        width: "fit-content",
        bg: "primary",
        className: l(m.modal, r),
        ...s,
        children: t
      }
    )
  ] }) }) : null;
}, E = ({ children: t, className: o, ...r }) => /* @__PURE__ */ a(
  c,
  {
    align: "center",
    gap: "md",
    margin: "0 md",
    padding: "md 0",
    justify: "between",
    className: l(m.modal__header, o),
    ...r,
    children: t
  }
), G = ({ children: t, ...o }) => /* @__PURE__ */ a(f, { size: "T400", weight: "regular", color: "inherit", ...o, children: t }), J = ({
  className: t = "",
  children: o,
  ...r
}) => /* @__PURE__ */ a(
  i,
  {
    className: l(m["modal__close-button"], t),
    ...r,
    children: o || /* @__PURE__ */ a(p, { icon: h })
  }
), i = ({
  children: t,
  onClick: o,
  ...r
}) => {
  const d = n();
  return /* @__PURE__ */ a(
    "button",
    {
      type: "button",
      onClick: (s) => {
        d == null || d.setIsOpen(!1), o == null || o(s);
      },
      ...r,
      children: t
    }
  );
}, K = ({ children: t, className: o, ...r }) => /* @__PURE__ */ a(
  u,
  {
    className: l(m.modal__body, o),
    padding: "md",
    overflow: "auto",
    ...r,
    children: t
  }
), P = ({ children: t, ...o }) => /* @__PURE__ */ a(c, { padding: "0 md md md", direction: "column", gap: "sm", ...o, children: t });
export {
  A as Modal,
  K as ModalBody,
  q as ModalButton,
  J as ModalCloseButton,
  i as ModalDismissButton,
  P as ModalFooter,
  E as ModalHeader,
  G as ModalTitle,
  k as ModalTrigger
};
